import React from 'react';

const DisabledInput = () => {
  return (
    <input
      className="input-message"
      type="text"
      name="message"
      id="message"
      autoComplete="off"
      value=""
      placeholder="Desabilitado, por favor escolha uma opção acima."
      disabled="disabled"
    />
  );
};

export default DisabledInput;
